module.exports = __webpack_public_path__ + "img/safari.c72439b5.png";